<template>
  <span class="icon-unnecessary">/</span>
</template>
<script>
export default {
  name: 'icon-unnecessary',
}
</script>
<style lang="less">
.icon-unnecessary {
  font-size: 16px;
  line-height: 16px;
  vertical-align: middle;
  color: #999;
  display: inline-block;
  width: 20px;
  text-align: left;
  padding-left: 6px;
  box-sizing: border-box;
}
</style>